import PageAction from './action/page-action.js'
import VideoAction from './action/video-action.js'
//import NewsletterAction from './action/newsletter-action.js'

var domReady = function(callback) {
    document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback, false);
};

domReady(function() {
  let actions = [];
  actions.push(new PageAction());
  actions.push(new VideoAction());
  //actions.push(new NewsletterAction());
});